module.exports = __webpack_public_path__ + "static/tkuchiki-f548663a246f0cdb293fe4c97235a451.jpg";